import * as React from "react"

import "./cta_callout.scss"

const CTACallout = ({headline, headlineBold, buttonText, buttonHref }) => {
  return (
    <section>
    <div className="cta-callout text-center ">
      <div className="container">
        <div className="row justify-content-md-center">
            <div className="col-sm-12 col-md-10 col-lg-10">
              <h2 className="mx-0 px-0 display-6">{headline}</h2>
              <h2><strong>{headlineBold}</strong></h2>    
              <div className="pt-4 pt-lg-5 text-center d-flex align-items-center justify-content-evenly">
              <a href={buttonHref}><button className="bg-primary blue-cta-button p-2 px-4 mt-2 w-100 d-flex align-items-center justify-content-evenly">{buttonText}</button></a>       
              </div>    
            </div>
        </div>
      </div>
    </div>
    </section>
  )
}

export default CTACallout
